import React, { useCallback, useEffect, useRef, useState } from "react";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import useTabs from "../hooks/useTabs";
import * as apis from "../apis";

export default function PrivacyPolicyContainer() {
  const tabButtons = [
    { id: 1, tab: "한국어", locale: "ko" },
    { id: 2, tab: "영문", locale: "en" },
  ];

  const { currentItem, changeItem } = useTabs(0, tabButtons);

  const editorRef = useRef(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [privacyPolicy, setPrivacyPolicy] = useState({
    content: "",
    locale: currentItem.locale,
  });

  useEffect(() => {
    const fetchPrivacyPolicy = async () => {
      try {
        const res = await apis.getPrivacyPolicy(currentItem.locale);
        setPrivacyPolicy(res?.data?.data);
        setIsDataLoaded(true);
      } catch (error) {
        console.error(error);
        alert(
          error.response?.data?.message ||
            "개인정보 처리 방침을 불러오는데 실패 하였습니다."
        );
      }
    };
    fetchPrivacyPolicy();
  }, [currentItem.locale]);

  const handleEditorChange = (name, value) => {
    setPrivacyPolicy((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = useCallback(async () => {
    if (!privacyPolicy.content.trim()) {
      alert("개인정보 처리 방침을 입력해주세요.");
      return;
    }

    try {
      if (window.confirm("개인정보 처리 방침을 저장하시겠습니까?")) {
        await apis.updatePrivacyPolicy(privacyPolicy);
        const message =
          privacyPolicy.locale === "ko"
            ? "한국어 개인정보 처리 방침이 저장되었습니다."
            : "영문 개인정보 처리 방침이 저장되었습니다.";

        alert(message);
      }
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "개인정보 처리 방침을 저장하는데 실패 하였습니다."
      );
    }
  }, [privacyPolicy]);

  return (
    <>
      {isDataLoaded && (
        <PrivacyPolicy
          tabButtons={tabButtons}
          currentItem={currentItem}
          changeItem={changeItem}
          privacyPolicy={privacyPolicy}
          editorRef={editorRef}
          handleEditorChange={handleEditorChange}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
}
